module.exports = __webpack_public_path__ + "assets/chart1.2.png?9fc9b8dcb4689a2a5246fc6eb29372d8";